import { TGetMatchResDto } from "@/api/services/main/match/dtos/get-match.dto";
import { TUpdateMatchReqDto, TUpdateMatchResDto } from "@/api/services/main/match/dtos/update-match.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { useQuery } from "@tanstack/react-query";

export const fetchMatchInfoApi = async (): Promise<TGetMatchResDto> => {
  const rs = await clientApi.get<TGetMatchResDto>("/match");
  return rs.data;
};

export const useGetMatchInfo = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.MATCH.FETCH_DETAIL],
    queryFn: () => fetchMatchInfoApi(),
  });
};

export const updateMatchApi = async (payload: TUpdateMatchReqDto): Promise<TUpdateMatchResDto> => {
  const rs = await clientApi.put<TUpdateMatchResDto>(`/match`, payload);
  return rs.data;
};
